export function formatUpperCase(str) {
    return str.replace('_', ' ');
}

export function formatTitleCase(str) {
    return str
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
